import { render } from "./rwce_program_consent_checkbox.vue?vue&type=template&id=66a45a52"
import script from "./rwce_program_consent_checkbox.vue?vue&type=script&lang=js"
export * from "./rwce_program_consent_checkbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__